<template>
  <div class="slide k-slide">
    <div class="k-slide-con">
      <div class="k-slide-nav" :style="{ width: slidewidth + 'px' }">
        <el-menu ref="menu" :unique-opened="false" :router="true" :default-active="defaultActive">
          <!-- :default-openeds="info.defaultOpeneds" -->
          <template v-for="val in info.clickMenus">
            <el-menu-item :key="val.url" :index="val.url" v-if="val.show == 'SHOW'">
              <i :class="val.icon"></i>
              <span slot="title">{{val.label}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="k-slide-button">
        <i :class="activeClass" @click="toggleNav()"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: ['info'],
  data() {
    return {
      slidewidth: 160,
      activeClass: 'el-icon-s-fold'
    }
  },
  computed: {
    defaultActive: function() {
      return this.$route.path ? this.$route.path : '/'
    }
  },
  methods: {
    toggleNav: function() {
      this.isCollapse = !this.isCollapse
      if (this.isCollapse) {
        this.activeClass = 'el-icon-s-unfold'
        this.slidewidth = 44
      } else {
        this.activeClass = 'el-icon-s-fold'
        this.slidewidth = 160
      }
    }
  }
}
</script>
<style scoped>
.k-slide-con {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid #e8eaec;
  background-color: #fff;
}
.k-slide-con .el-menu {
  border-right: none !important;
}
.k-slide-con .k-slide-nav {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  width: 160px;
}
.k-slide-con .k-slide-nav .el-menu-item {
  padding-left: 10px !important;
}
.k-slide-con .k-slide-button {
  height: 40px;
  margin-right: 6px;
  line-height: 40px;
  color: #979797;
  text-align: right;
  font-size: 16px;
}
.k-slide-con .k-slide-button i {
  cursor: pointer;
}
</style>
